import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  Container,
  FormFeedback,
} from "reactstrap"
import { useNavigate, useLocation } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"

import { addAwardCategory } from "../../../redux/actions/awards"
import { ADD_AWARD_CATEGORY_RESET } from "../../../redux/types/awards"
import SuccessPopup from "../../../components/SuccessPopup"
import ErrorPopup from "../../../components/ErrorPopup"

function AddAwardCategory() {
  document.title = "Add Award Category | Admin Dashboard"

  const history = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  const { enc_award_id } = location.state || {}

  const addAwardCategoryScreen = useSelector(
    state => state.screens.awards.addAwardCategory
  )

  const [successOpen, setSuccessOpen] = useState(false)
  const [errorOpen, setErrorOpen] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")

  useEffect(() => {
    if (addAwardCategoryScreen && addAwardCategoryScreen.success) {
      setSuccessOpen(true)
    } else if (addAwardCategoryScreen && addAwardCategoryScreen.error) {
      setErrorMsg(addAwardCategoryScreen.error || "Unable to add category.")
      setErrorOpen(true)
    }
  }, [addAwardCategoryScreen])

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      category: "",
    },

    validationSchema: Yup.object({
      category: Yup.string().required("Category name is required"),
    }),

    onSubmit: values => {
      dispatch(
        addAwardCategory({
          enc_award_id,
          category: values.category,
        })
      )
    },
  })

  return (
    <React.Fragment>
      <SuccessPopup
        isOpen={successOpen}
        toggle={() => setSuccessOpen(false)}
        onConfirm={() => {
          setSuccessOpen(false)
          dispatch({ type: ADD_AWARD_CATEGORY_RESET })
          history(-1)
        }}
        message="Category added successfully!"
      />
      <ErrorPopup
        isOpen={errorOpen}
        toggle={() => {
          setErrorOpen(false)
          dispatch({ type: ADD_AWARD_CATEGORY_RESET })
        }}
        message={errorMsg}
      />

      <div className="page-content">
        <Container fluid={true}>
          <div className="mb-3 pb-2"></div>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h2 className="h4 nom-title mb-0">Add Award Category</h2>
          </div>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Form
                    className="mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      formik.handleSubmit()
                      return false
                    }}
                    action="#"
                  >
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="category">
                          Category Name
                        </Label>
                        <Input
                          name="category"
                          id="category"
                          className="form-control"
                          placeholder="Enter category name"
                          type="text"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.category || ""}
                          invalid={
                            formik.touched.category && formik.errors.category
                              ? true
                              : false
                          }
                        />
                        {formik.touched.category && formik.errors.category ? (
                          <FormFeedback type="invalid">
                            {formik.errors.category}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    <div className="d-flex gap-2 mt-2">
                      <Button
                        type="submit"
                        color="primary"
                        disabled={addAwardCategoryScreen.loading}
                      >
                        {addAwardCategoryScreen.loading
                          ? "Adding..."
                          : "Add Category"}
                      </Button>
                      <Button
                        type="button"
                        color="secondary"
                        onClick={() => history(-1)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddAwardCategory
